import { Inject, Injectable } from '@angular/core';
import { Package, PackageService, Status } from '@vendasta/marketplace-packages';
import { Observable, combineLatest } from 'rxjs';
import { map, shareReplay, switchMap } from 'rxjs/operators';
import { MARKET_ID_TOKEN, PARTNER_ID_TOKEN } from './tokens';

@Injectable()
export class PipelineFilterPackageStoreService {
  public packages$: Observable<Package[]>;
  constructor(
    private readonly pkgService: PackageService,
    @Inject(PARTNER_ID_TOKEN) private readonly partnerId$: Observable<string>,
    @Inject(MARKET_ID_TOKEN) private readonly marketId$: Observable<string>,
  ) {
    this.packages$ = combineLatest([this.partnerId$, this.marketId$]).pipe(
      switchMap(([partnerId, marketId]) =>
        this.pkgService.loadAllPackages(partnerId, [Status.PUBLISHED], marketId, false, 10000),
      ),
      map((resp) => resp.packages),
      map((packages) => packages.sort((a, b) => (a.name > b.name ? 1 : -1))),
      shareReplay({ bufferSize: 1, refCount: true }),
    );
  }
}
